import * as React from 'react';
import styled from 'styled-components';

import {COLORS, ComponentTextStyle, invertedFocusStyles} from '../../styles';
import {SystemIcons} from '../../icons';
import {NavSection} from '../../types';
import {ComponentMStyling, ComponentSStyling} from '../../styles';
import {HyperLink} from '../../HyperLink';
import {defaultOnMouseDownHandler} from '../../common';

const Wrapper = styled.div`
  width: 100%;
  border-top: 1px solid ${COLORS.neutral_100};

  &:last-child {
    border-bottom: 1px solid ${COLORS.neutral_100};
  }
`;

const DropdownLinkBlock = styled.button<{ width: number }>`
  ${ComponentSStyling(ComponentTextStyle.Bold, COLORS.white)}

  display: ${(props) => (props.width > 768 ? 'none' : 'flex')};
  justify-content: space-between;
  width: 100%;
  height: 48px;
  background-color: transparent;
  border: none;
  padding: 0 16px;

  &:hover,
  .open {
    background-color: ${COLORS.neutral_20};
    color: ${COLORS.primary_700};
  }

  &:hover {
    cursor: pointer;
  }

  &:active {
    background-color: ${COLORS.primary_100};
    color: ${COLORS.primary_800};
  }

  &:focus {
    ${invertedFocusStyles}
  }

  h3 {
    margin: auto 0;
    ${ComponentMStyling(ComponentTextStyle.Regular, 'inherit')}
  }

  .open {
    h3 {
      background-color: ${COLORS.neutral_20};
      color: ${COLORS.neutral_800};
    }
  }

  svg {
    margin: auto 0;
  }
`;

const LinkBlock = styled.div<{ width: number }>`
  display: none;
  flex-direction: column;
  font-weight: normal;
  width: 100%;

  &.show {
    display: flex;
  }

  a {
    text-decoration: none;

    ${ComponentSStyling(ComponentTextStyle.Bold, COLORS.white)}
    
    display: flex;
    align-items: center;
    
    padding: 0 16px;
    height: 48px;

    &:hover {
      background-color: ${COLORS.neutral_20};
      color: ${COLORS.primary_700};
      cursor: pointer;
    }

    &:focus {
      ${invertedFocusStyles}
    }

    &:active {
      background-color: ${COLORS.primary_100};
      color: ${COLORS.primary_800};
    }
  }
`;

interface FooterNavSectionProps {
  navSection: NavSection;
  width: number;
}

const FooterDropdownLinks = ({ navSection, width }: FooterNavSectionProps) => {
  const [dropdownActive, setDropdownActive] = React.useState<boolean>(false);
  return (
    <Wrapper>
      <DropdownLinkBlock width={width}
                         className={dropdownActive ? 'open' : ''}
                         onMouseDown={defaultOnMouseDownHandler}
                         onClick={() => setDropdownActive(!dropdownActive)}>
        <h3>{navSection.header}</h3>
        {dropdownActive ? <SystemIcons.ChevronUp size="24px" /> : <SystemIcons.ChevronDown size="24px" />}
      </DropdownLinkBlock>
      <LinkBlock width={width} className={dropdownActive ? 'show' : ''}>
        {navSection.links.map((item, index) => (
          <HyperLink key={index}
                     id={`dropdownlink_${Math.floor(Math.random() * 999999999999)}`}
                     variant={'inverted'}
                     href={item.to}
                     target={item.target || '_blank'}
                     rel="noreferrer noopener">
            {item.label}
          </HyperLink>
        ))}
      </LinkBlock>
    </Wrapper>
  );
};

export default FooterDropdownLinks;
